<h1 mat-dialog-title>{{ data.title | translate }}</h1>
<div mat-dialog-content>
  <div class="message-content">
    <span [innerHTML]="data.message | translate"></span>
  </div>
</div>
<input #el class="invisible" type="text" [value]="data.url" />

<div mat-dialog-actions>
  <span fxFlex></span>
  <button
    mat-button
    color="accent"
    ix-auto
    ix-auto-type="button"
    ix-auto-identifier="{{ 'Cancel' | uppercase }}"
    (click)="dialogRef.close(false)"
  >
    {{ 'Cancel' | translate }}
  </button>
  <button
    mat-button
    color="accent"
    ix-auto
    ix-auto-type="button"
    ix-auto-identifier="{{ 'Copy_URL' | uppercase }}"
    (click)="copyToClipboard()"
  >
    {{ 'Copy URL' | translate }}
  </button>
  <button
    mat-button
    color="primary"
    ix-auto
    ix-auto-type="button"
    ix-auto-identifier="{{ 'Continue' | uppercase }}"
    (click)="dialogRef.close(true)"
  >
    {{ 'Continue' | translate }}
  </button>
</div>
